import React from "react";

import { Button } from "../../JobsPage/components/Button";

const OutlookConnect = () => {
	const CLIENT_ID = "eb5340b5-2317-4249-a740-b6397f84b439";
	const REDIRECT_URI = "http://localhost:3000/email-auth-callback";

	const handleOnSubmit = () => {
		const state = Math.random().toString(36).substring(7);
		const scope = "openid email https://graph.microsoft.com/Mail.Send offline_access";

		window.location.href = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=${CLIENT_ID}&redirect_uri=${encodeURIComponent(
			REDIRECT_URI,
		)}&response_type=code&scope=${encodeURIComponent(scope)}&state=${state}`;
	};

	return (
		<Button
			className="inline-flex min-w-fit items-center justify-center bg-primary-700 text-white px-4 h-9 rounded hover:bg-primary-800 transition-colors duration-300 text-sm font-inter w-[90px] group relative overflow-hidden"
			onClick={handleOnSubmit}
		>
			Connect Outlook
		</Button>
	);
};

export default OutlookConnect;
